<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path stroke="currentColor" d="M0 10.459V0" style="fill:none;stroke-linecap:round;stroke-width:1.4px" transform="rotate(45 3.653 17.488)" fill="currentColor"/><path stroke="currentColor" d="M610.861 15.365h5.384v5.384" style="stroke-linejoin:round;fill:none;stroke-linecap:round;stroke-width:1.4px" transform="translate(-602.81 -12.826)" fill="currentColor"/><path stroke="currentColor" d="M-8268.12-15250.309h-2.154v10.924h10.869v-2.2" style="stroke-linejoin:round;fill:none;stroke-linecap:round;stroke-width:1.4px" transform="translate(8272.839 15252.848)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-browser-open',
});
</script>
